@if(field(); as field)
{
<div class="input-group">
	<span class="input-group-text">
		@if(field.saving()){<i class="fa-fw fa-regular fa-spin fa-spinner-third"></i>}
		@else if(errorToShow() !== ''){<i class="fa-fw fa-solid fa-circle-xmark color-darkred"></i>}
		@else if(customIcon()){<i [ngClass]="customIcon()"></i>}
		@else{<i class="fa-fw fa-regular fa-hand-pointer"></i>}
	</span>
	<div class="eforall-common-field form-floating">
		<select class="form-select form-select-sm" [id]="randomId" [ngModel]="renderedModel()"
			(ngModelChange)="onChange($event)" (blur)='onBlur()' (focus)="onFocus()" [disabled]="!isEnabled()">
			<!-- Using ngValue avoids string coercion and keeps the actual type (boolean, number, object) -->
			<option disabled [ngValue]="defaultValue()">{{labels().select()}}...</option>
			@for(option of field.config().options; track option.value;)
			{
			<option [ngValue]="option.value" [disabled]="option.disabled">
				{{option.text}}{{option.subText ? ': ' + option.subText : ''}}
			</option>
			}
		</select>
		<label class="color-gray d-flex" [for]="randomId">
			{{field.config().label}}{{!field.config().isRequired ? ' ' + labels().optionalWithParentheses() :''}}
		</label>

	</div>
</div>

@if(errorToShow() !== '')
{
<div class="color-darkred text-end">{{errorToShow()}}</div>
}
}